import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import TransactionTable from '../../../components/tables/TransactionTable';

const SearchTransaction = () => {
  // Helper function to get date in YYYY-MM-DD format
  const getFormattedDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Get current date and 7 days ago date
  const today = new Date();
  const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
  const defaultDateFrom = getFormattedDate(sevenDaysAgo);
  const defaultDateTo = getFormattedDate(today);

  const [searchParams, setSearchParams] = useState({
    transactionId: '',
    dateFrom: defaultDateFrom,
    dateTo: defaultDateTo,
    status: ''
  });
  const [searchResults, setSearchResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);

  // Sample data generator for search results
  const generateSearchResults = () => {
    const userRoles = [
      'Super Distributor',
      'Master Distributor',
      'Distributor',
      'Retailer',
      'API Partner'
    ];
    const statuses = ['Success', 'Failed', 'Pending'];
    const types = ['Credit', 'Debit'];
    const names = [
      'Rajesh Kumar', 'Priya Sharma', 'Amit Patel', 'Sneha Reddy',
      'Vikram Singh', 'Anjali Gupta', 'Rahul Verma', 'Neha Joshi'
    ];

    const count = Math.floor(Math.random() * 20) + 5;
    return Array.from({ length: count }, (_, i) => {
      const transactionDate = new Date(
        2024,
        Math.floor(Math.random() * 12),
        Math.floor(Math.random() * 28) + 1
      );

      return {
        id: `TXN${String(i + 1).padStart(6, '0')}`,
        userName: names[Math.floor(Math.random() * names.length)],
        userRole: userRoles[Math.floor(Math.random() * userRoles.length)],
        type: types[Math.floor(Math.random() * types.length)],
        amount: [500, 1000, 2000, 5000, 10000, 15000, 20000][
          Math.floor(Math.random() * 7)
        ],
        transactionDate: transactionDate.toISOString().split('T')[0],
        status: statuses[Math.floor(Math.random() * statuses.length)]
      };
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchParams(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    // Simulate search - in real app, this would call API
    const results = generateSearchResults();
    setSearchResults(results);
    setHasSearched(true);
  };

  const handleReset = () => {
    setSearchParams({
      transactionId: '',
      dateFrom: defaultDateFrom,
      dateTo: defaultDateTo,
      status: ''
    });
    setSearchResults([]);
    setHasSearched(false);
  };

  return (
    <Container fluid className="">
      {/* Search Form */}
      <Card className="mb-3 shadow-sm">
        <Card.Body className="py-3">
          <Form onSubmit={handleSearch}>
            <Row className="g-2">
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Mobile / Transaction Id</Form.Label>
                  <Form.Control
                    size="sm"
                    type="text"
                    name="transactionId"
                    placeholder="Enter mobile or transaction ID"
                    value={searchParams.transactionId}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">From Date</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    name="dateFrom"
                    value={searchParams.dateFrom}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">To Date</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    name="dateTo"
                    value={searchParams.dateTo}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Status</Form.Label>
                  <Form.Select
                    size="sm"
                    name="status"
                    value={searchParams.status}
                    onChange={handleInputChange}
                  >
                    <option value="">All Status</option>
                    <option value="Success">Success</option>
                    <option value="Pending">Pending</option>
                    <option value="Failed">Failed</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">&nbsp;</Form.Label>
                  <div className="d-flex gap-2">
                    <Button 
                      type="submit" 
                      size="sm"
                      className="w-100"
                      style={{
                        backgroundColor: 'transparent',
                        border: '1px solid #0d6efd',
                        color: '#0d6efd',
                        fontWeight: '500',
                        padding: '4px 8px',
                        fontSize: '0.875rem'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#0d6efd';
                        e.currentTarget.style.color = 'white';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.color = '#0d6efd';
                      }}
                    >
                      <i className="bi bi-search me-2"></i>
                      Search
                    </Button>
                    <Button 
                      onClick={handleReset}
                      size="sm"
                      className="w-100"
                      style={{
                        backgroundColor: 'transparent',
                        border: '1px solid #6c757d',
                        color: '#6c757d',
                        fontWeight: '500',
                        padding: '4px 8px',
                        fontSize: '0.875rem'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#6c757d';
                        e.currentTarget.style.color = 'white';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.color = '#6c757d';
                      }}
                    >
                      <i className="bi bi-arrow-clockwise me-2"></i>
                      Reset
                    </Button>
                  </div>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {/* Search Results */}
      {hasSearched && (
        <TransactionTable
          data={searchResults}
          title=""
          hideSearch={true}
          hideTitle={true}
        />
      )}
    </Container>
  );
};

export default SearchTransaction;

